import React from "react";
import { Col, Space } from "antd";
import RentB2bList from "../../components/RentB2bList";

function RentB2bManagement() {
    return (
        <div className="container">
            <Space size={30} direction="vertical" style={{ width: "100%" }}>
                <h3 className="title">B2B 관리</h3>
                <RentB2bList />
            </Space>
        </div>
    );
}

export default RentB2bManagement;
